"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "modal-status" };
const CalendarFooterItems_vue_1 = __importDefault(require("../footer/CalendarFooterItems.vue"));
const vue_3 = require("vue");
const i18n_1 = __importDefault(require("../../../../common/i18n"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ModalStatus',
    props: {
        status: {
            type: String,
            default: "",
        },
    },
    setup(__props) {
        const props = __props;
        const statusText = (0, vue_3.ref)("");
        (0, vue_3.watch)(() => props.status, (newStatus) => {
            if (newStatus === "Approved") {
                statusText.value = i18n_1.default.trans("Approved", "Approved", "status");
            }
            else if (newStatus === "New") {
                statusText.value = i18n_1.default.trans("new", "New", "status");
            }
            else if (newStatus === "Rejected") {
                statusText.value = i18n_1.default.trans("rejected", "Rejected", "status");
            }
        }, { immediate: true }); // `immediate: true` ensures the watcher runs immediately after the component is created
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                    icon: true,
                    text: __props.status
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (__props.status === 'New')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_font_awesome_icon, {
                                key: 0,
                                class: "fontawsome-icon text-yellow",
                                icon: ['fas', 'circle-exclamation']
                            }))
                            : (__props.status === 'Approved')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_font_awesome_icon, {
                                    key: 1,
                                    class: "fontawsome-icon text-green",
                                    icon: ['fas', 'check-square']
                                }))
                                : (__props.status === 'Rejected' || __props.status === 'Deleted')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_font_awesome_icon, {
                                        key: 2,
                                        class: "fontawsome-icon text-red",
                                        icon: ['fas', 'circle-xmark']
                                    }))
                                    : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }, 8, ["text"])
            ]));
        };
    }
});
